import api from 'src/utils/api/core'

export function getTugs(portUuid) {
  return api.get('/tugs', { params: { portUuid } })
}

export function getPilotageTugs(uuid) {
  return api.get(`/pilotages/${uuid}/pilotage_tugs?passOneStage=false`)
}

export function addPilotageTug(pilotageUuid, tugUuid, lineNumber, stageUuid) {
  return api.post(`/pilotage_tugs`, {
    lineNumber,
    pilotage: {
      uuid: pilotageUuid,
    },
    tug: {
      uuid: tugUuid,
    },
    stage: {
      uuid: stageUuid,
    }
  })
}

export function removePilotageTug(pilotageTugUuid) {
  return api.delete(`/pilotage_tugs/${pilotageTugUuid}`)
}
